import { get, isObjectLike, keys, flattenDeep, isUndefined, forEach, isNil } from 'lodash';
import { scrollTo } from 'utils/scroll';

export function pathContractor(object, path = '') {
  const pathArray = [];
  const currentObject = path ? get(object, path) : object;
  if (isObjectLike(currentObject)) {
    for (const key of keys(currentObject)) {
      const newPath = pathContractor(object, `${path}[${key}]`);
      if (newPath) {
        pathArray.push(newPath);
      }
    }
    return flattenDeep(pathArray);
  }
  return !isUndefined(currentObject) && !isNil(currentObject) ? normalizePath(path) : '';
}
function normalizePath(path = '') {
  const openBracketRegexp = /\[(?!\d)/g;
  const closeBracketRegexp = /[a-zA-z]\]/g;
  const closingDotRegexp = /\.(?=\[)|(\.)[\.]*$/g;
  return path
    .replace(closeBracketRegexp, (str) => `${str.substr(0, 1)}.`)
    .replace(openBracketRegexp, '')
    .replace(closingDotRegexp, '');
}

export function scrollToFirstFormError(fromError) {
  const pathsArray = pathContractor(fromError);
  const firstError = returnFirstError(pathsArray);
  if (firstError) {
    scrollTo(firstError, { offset: -50, smooth: true, ignoreCancelEvents: true });
  }
}
function returnFirstError(pathsArray) {
  const firstErrorObject = {
    topCoordinate: 0,
    path: '',
  };
  forEach(pathsArray, (path) => {
    const element = document.getElementById(path);
    const topCoordinate = element && element.getBoundingClientRect().top;
    if (topCoordinate && topCoordinate < firstErrorObject.topCoordinate) {
      firstErrorObject.topCoordinate = topCoordinate;
      firstErrorObject.path = path;
    }
  });
  return firstErrorObject.path;
}
